import clsx from 'clsx';

export function authTremorTextInputRootClass(dense: boolean, error: boolean): string {
  return clsx(
    'shadow-sm rounded-lg !min-w-0 bg-white border',
    '!ring-0 !ring-offset-0 focus-within:!ring-0 focus-within:!ring-offset-0',
    dense ? '[&_input]:py-2' : '[&_input]:py-2.5',
    '[&_input]:text-sm [&_input]:text-gray-900 [&_input]:placeholder:text-gray-400',
    '[&_input]:!ring-0 [&_input]:!ring-offset-0 [&_input]:focus:!ring-0 [&_input]:focus:!outline-none',
    error
      ? '!border-2 !border-red-500 focus-within:!border-red-600'
      : '!border-gray-300 focus-within:!border-primary-500',
  );
}

export const authTremorButtonNoFocusRing =
  'focus:!outline-none focus-visible:!outline-none focus:!ring-0 focus-visible:!ring-0 !ring-0 !ring-offset-0 focus:!ring-offset-0 focus-visible:!ring-offset-0 focus-visible:!ring-0';

export const authTremorPrimarySubmitClass = [
  'w-full !rounded-lg !border-transparent !bg-primary-500 !text-white !shadow-md transform transition-all duration-200 hover:-translate-y-0.5 hover:!bg-primary-600 disabled:!translate-y-0 disabled:!cursor-not-allowed disabled:!bg-gray-400 disabled:!shadow-md',
  authTremorButtonNoFocusRing,
].join(' ');
